import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { Form, Button, Row, Col, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { adminInstance } from '../services/axiosInstance';

const ManageUserPage = () => {
  const navigate = useNavigate();
    const { userId } = useParams();
    const roles = [
        { label: "Coordinator", value: "Coordinator" },
        { label: "Manager", value: "Manager" },
        { label: "MD - Management", value: "MD" },
        { label: "Commercial", value: "Commercial" },
        { label: "Auditor", value: "Auditor" }
    ];
    const states = [
        { label: "Andhra Pradesh", value: "Andhra Pradesh" },
        { label: "Arunachal Pradesh", value: "Arunachal Pradesh" },
        { label: "Assam", value: "Assam" },
        { label: "Bihar", value: "Bihar" },
        { label: "Chhattisgarh", value: "Chhattisgarh" },
        { label: "Goa", value: "Goa" },
        { label: "Gujarat", value: "Gujarat" },
        { label: "Haryana", value: "Haryana" },
        { label: "Himachal Pradesh", value: "Himachal Pradesh" },
        { label: "Jharkhand", value: "Jharkhand" },
        { label: "Karnataka", value: "Karnataka" },
        { label: "Kerala", value: "Kerala" },
        { label: "Madhya Pradesh", value: "Madhya Pradesh" },
        { label: "Maharashtra", value: "Maharashtra" },
        { label: "Manipur", value: "Manipur" },
        { label: "Meghalaya", value: "Meghalaya" },
        { label: "Mizoram", value: "Mizoram" },
        { label: "Nagaland", value: "Nagaland" },
        { label: "Odisha", value: "Odisha" },
        { label: "Punjab", value: "Punjab" },
        { label: "Rajasthan", value: "Rajasthan" },
        { label: "Sikkim", value: "Sikkim" },
        { label: "Tamil Nadu", value: "Tamil Nadu" },
        { label: "Telangana", value: "Telangana" },
        { label: "Tripura", value: "Tripura" },
        { label: "Uttar Pradesh", value: "Uttar Pradesh" },
        { label: "Uttarakhand", value: "Uttarakhand" },
        { label: "West Bengal", value: "West Bengal" },
        { label: "Andaman and Nicobar Islands", value: "Andaman and Nicobar Islands" },
        { label: "Chandigarh", value: "Chandigarh" },
        { label: "Dadra and Nagar Haveli and Daman and Diu", value: "Dadra and Nagar Haveli and Daman and Diu" },
        { label: "Delhi", value: "Delhi" },
        { label: "Jammu and Kashmir", value: "Jammu and Kashmir" },
        { label: "Ladakh", value: "Ladakh" },
        { label: "Lakshadweep", value: "Lakshadweep" },
        { label: "Puducherry", value: "Puducherry" }
    ];
  
  const [user, setUser] = useState(false);
  const initialValues = {
    USER_ID: user.UserId,
    USER_NAME: user.UserName,
    USER_STATE: user.UserState,
    ALLOW_SECTION: user.AllowSection,
    IS_ADMIN: user.IsAdmin,
    IS_ACTIVE: user.IsActive,
    EMP_ID: user.EmpId
  };
    const [loading, setLoading] = useState(false);
    const [employee, setEmployee] = useState([]);

  const validationSchema = Yup.object().shape({
    USER_NAME: Yup.string().required('User name is required'),
  });

  useEffect(() => {
    loadEmployee();
    if (userId) {
      setLoading(true);
      adminInstance.get(`user/GetById/${userId}`)
        .then(res => {
            setUser(res.data);
        })
        .catch(err => {
          console.error('Error fetching user:', err);
        })
        .finally(() => setLoading(false));
    }
  }, [userId]);

    const loadEmployee = async () => {
        var empList = sessionStorage.getItem('empList');

        if (empList) {
            setEmployee(JSON.parse(empList));
        }
        else {
            try {
                const response = await adminInstance.get("user/getemployee");
                setEmployee(response.data || []);
                sessionStorage.setItem('empList', JSON.stringify(response.data));
            } catch (error) {
                console.error('Error fetching employee:', error.message);
            } finally {
                console.log('Fetch process completed.');
            }
        }
    }

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const url = userId ? `user/update/${userId}` : 'user/save';

      if(userId){
          await adminInstance.put(url, values);
      }
      else{
        await adminInstance.post(url, values);
      }

      alert('User saved successfully');
      navigate('/userlist');
    } catch (error) {
      console.error('Error saving user:', error);
      alert('Failed to save user');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return <div className="text-center p-5"><Spinner animation="border" /></div>;
  }

  return (
    <div className="card aon-card">
        <div className="card-header aon-card-header">
            <h4>
                Manage User
            </h4>
        </div>
        <div className="card-body aon-card-body">
            <div className="container mt-4">
            <h4>{userId ? 'Update User' : 'Create User'}</h4>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({
                values,
                errors,
                touched,
                handleChange,
                handleSubmit,
                handleBlur,
                isSubmitting,
                setFieldValue,
                }) => (
                <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="USER_STATE">
                          <Form.Label>State</Form.Label>
                          <Form.Control
                            as="select"
                            multiple
                            name="USER_STATE"
                            //value={values.USER_STATE}
                            value={values.USER_STATE ? values.USER_STATE.split(",") : []}
                            //onChange={handleChange}
                            onChange={(e) => {
                              const selectedOptions = Array.from(e.target.selectedOptions).map(option => option.value);
                              setFieldValue("USER_STATE", selectedOptions.join(","));
                            }}
                            onBlur={handleBlur}
                            isInvalid={touched.USER_STATE && !!errors.USER_STATE}
                          >
                            <option value="">Select State</option>
                            {states && states.map((group) => (
                              <option key={group.value} value={group.value}>
                                {group.label}
                              </option>
                            ))}
                          </Form.Control>
                          <Form.Control.Feedback type="invalid">{errors.USER_STATE}</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="ALLOW_SECTION">
                            <Form.Label>Roles</Form.Label>
                            <Form.Control
                                as="select"
                                multiple
                                name="ALLOW_SECTION"
                                //value={values.USER_STATE}
                                value={values.ALLOW_SECTION ? values.ALLOW_SECTION.split(",") : []}
                                //onChange={handleChange}
                                onChange={(e) => {
                                    const selectedOptionss = Array.from(e.target.selectedOptions).map(option => option.value);
                                    setFieldValue("ALLOW_SECTION", selectedOptionss.join(","));
                                }}
                                onBlur={handleBlur}
                                isInvalid={touched.ALLOW_SECTION && !!errors.ALLOW_SECTION}
                            >
                                              
                                {roles && roles.map((group) => (
                                    <option key={group.value} value={group.value}>
                                        {group.label}
                                    </option>
                                ))}
                            </Form.Control>
                                          <Form.Control.Feedback type="invalid">{errors.ALLOW_SECTION}</Form.Control.Feedback>
                        </Form.Group>
                                  </Col>
                              </Row>
                              <br />
                              <Row>
                    <Col md={6}>
                        <Form.Group controlId="USER_NAME" className="mb-3">
                        <Form.Label>User Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="USER_NAME"
                            value={values.USER_NAME}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.USER_NAME && errors.USER_NAME}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.USER_NAME}
                        </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    
                    <Col md={6}>
                        <Form.Group controlId="EMP_ID">
                            <Form.Label>Employee</Form.Label>
                            <Form.Control
                                as="select"
                                name="EMP_ID"
                                value={values.EMP_ID}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isInvalid={touched.EMP_ID && !!errors.EMP_ID}
                            >
                                <option value="">Select Employee</option>
                                {employee && employee.map((emp) => (
                                    <option key={emp.EmpId} value={emp.EmpId}>
                                        {emp.EmpName}
                                    </option>
                                ))}
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">{errors.EMP_ID}</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group controlId="IS_ADMIN" className="mb-3">
                        <Form.Check
                            type="checkbox"
                            label="Is Admin"
                            name="IS_ADMIN"
                            checked={!!values.IS_ADMIN}
                            onChange={e => setFieldValue('IS_ADMIN', e.target.checked)}
                        />
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group controlId="IS_ACTIVE" className="mb-3">
                        <Form.Check
                            type="checkbox"
                            label="Is Active"
                            name="IS_ACTIVE"
                            checked={!!values.IS_ACTIVE}
                            onChange={e => setFieldValue('IS_ACTIVE', e.target.checked)}
                        />
                        </Form.Group>
                    </Col>
                              </Row><br/>
                              <Row>
                                  <Col md={6}>
                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? 'Saving...' : 'Save'}
                    </Button>{' '}
                    <Button variant="secondary" onClick={() => navigate(-1)}>
                    Cancel
                                      </Button>
                                  </Col>
                              </Row>
                </Form>
                )}
            </Formik>
            </div>
        </div>
    </div>
  );
};

export default ManageUserPage;
